import React, { FC, useEffect } from 'react';
import { Wrapper } from './styles';
import LayoutComponent from './components/LayoutComponent';
import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import { ProfileForm } from 'applicaiton/constants/clincOwnerProfile';
import ProfessionalAdd from 'features/feature-professional-add';
import ProfessionalEdit from 'features/feature-professional-edit';
import { resetClinicOwnerProfile } from 'applicaiton/store/reducers/ClinicOwner/ClinicOwnerSlice';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';
import { completeFirstLogin } from 'applicaiton/store/reducers/Users/ActionCreators';

const ClinicOwnerProfile: FC = () => {
  const dispatch = useAppDispatch();
  const { activeForm } = useAppSelector((state) => state.clinicOwnerSlice);
  const { profile } = useAppSelector((state) => state.users);

  const previewProfile = activeForm === ProfileForm.previewProfile;
  const createProfessionalProfile =
    activeForm === ProfileForm.createProfessionalProfile;
  const editProfessionalProfile =
    activeForm === ProfileForm.editProfessionalProfile;
  const { isExpiredSoon, isBlocked } = useSubscription();

  useEffect(() => {
    if (!profile?.isFirstLoginCompleted) {
      dispatch(completeFirstLogin());
    }

    return () => {
      dispatch(resetClinicOwnerProfile());
    };
  }, []);

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <>
      {previewProfile && (
        <Wrapper>
          {isExpiredSoon && <SubscriptionsExpiredSoon />}
          <LayoutComponent />
        </Wrapper>
      )}
      {createProfessionalProfile && <ProfessionalAdd />}
      {editProfessionalProfile && <ProfessionalEdit />}
    </>
  );
};

export default ClinicOwnerProfile;
